import { useState } from "react";
import ecgsService from "../../services/ecgs.service";
import ViewFileForm, {
  ViewFileFormInputs,
} from "../Shared/ViewFile/ViewFileForm/ViewFileForm";

import OpenReport from "../Shared/OpenReport/OpenReport";
import { FormWarning, Loader } from "@shltelemedicine/shl-ui-lib";

type ViewEcgProps = { pdfToken?: string };

const ViewEcg = ({ pdfToken }: ViewEcgProps) => {
  const [loading, setLoading] = useState(false);
  const [isErr, setIsErr] = useState(false);
  const [pdfFile, setPdfFile] = useState<Blob>();

  const viewEcgHandler = async ({
    username: userName,
    password,
  }: ViewFileFormInputs) => {
    if (!pdfToken) {
      setIsErr(true);
      return;
    }

    try {
      setLoading(true);
      const { success, data } = await ecgsService.downloadPdfByToken({
        pdfToken,
        userName,
        password,
      });

      setIsErr(!success);

      if (!success || !data) {
        return;
      }

      setPdfFile(data);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {pdfFile ? (
        <OpenReport
          file={pdfFile}
          titleStringId="VIEW_ECG.REPORT_CREATED"
          linkStringId="VIEW_ECG.VIEW_REPORT"
        />
      ) : (
        <>
          {loading ? (
            <div className="mb-3">
              <Loader />
            </div>
          ) : (
            <FormWarning
              message={
                isErr
                  ? "Something went wrong"
                  : "Insert username and password to view the report"
              }
              className={`${!isErr ? "app-hint" : ""} mb-3 px-3 font-md`}
            />
          )}
          <ViewFileForm onSubmit={viewEcgHandler} />
        </>
      )}
    </>
  );
};

export default ViewEcg;
